import { Card, Col, Row, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { AppStateContext } from "../../context/AppContext";
import NotificationList from "./_NotificationList";
import PushNotificationManager from "./_PushNotificationManager";

const { TabPane } = Tabs;

const notificationTabs = {
  NOTIFICATIONS: "Notifications",
  PUSH: "Push Notifications",
};

function Index() {
  const { setPageHeading } = useContext(AppStateContext);

  const [selectedTab, setSelectedTab] = useState(
    notificationTabs.NOTIFICATIONS
  );

  const handleTabChange = (status) => {
    setSelectedTab(status);
  };

  useEffect(() => {
    setPageHeading("Notifications");
  }, []);

  return (
    <>
      <div className="tabled quoteManagement">
        <Row gutter={[24, 0]}>
          <Col span={24} md={24} xl={24}>
            <Card bordered={false} className="criclebox tablespace mb-24">
              <Tabs
                className="main_tabs"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >
                <TabPane
                  tab={notificationTabs.NOTIFICATIONS}
                  key={notificationTabs.NOTIFICATIONS}
                >
                  <NotificationList />
                </TabPane>

                <TabPane
                  tab={notificationTabs.PUSH}
                  key={notificationTabs.PUSH}
                >
                  <PushNotificationManager />
                </TabPane>
              </Tabs>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Index;
